module.exports = __webpack_public_path__ + "img/index_icon5@2x.35ce5e40.png";